/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */
import { createAction, props } from '@ngrx/store';

import { User } from '@models/user.model';

export const login = createAction(
  '[Login/API] Login',
  props<{ payload: { email: string; password: string; successUrl?: string } }>()
);
export const loginSuccess = createAction(
  '[Login/API] Login Success',
  props<{ payload: { user: User; token: string; url?: string } }>()
);
export const loginFailure = createAction('[Login/API] Login Failure', props<{ payload: { errorMessage: string } }>());

export const resetLogin = createAction('[Login Page] Reset');
export const loginRedirect = createAction('[Login Page] Login Redirect');

export const setSessionAsExpired = createAction('[Login Page] Set Session as Expired');
